import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class NotificationPreferencesRequest {
  /**
   * Phone number.
   */
  @observable
  phoneNumber?: string;

  /**
   * If true - user is notified before the expiration of a charge by SMS.
   */
  @observable
  smsNotificationEnabled?: boolean;

  /**
   * If true - user is notified before the expiration of a charge by e-mail.
   */
  @observable
  emailNotificationEnabled?: boolean;

  /**
   * E-mail address.
   */
  @observable
  emailAddress?: string;
}
